import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { catchError, finalize } from 'rxjs/operators';


@Injectable()
export class LoadingScreenInterceptor implements HttpInterceptor {

    activeRequests = 0;

    /**
     * URLs for which the loading screen should not be enabled
     */
    skippUrls = [
        'contact',
        'legals',
        'privacy',
        'pterms-of-service'
    ];

    /**
     * url request for which the load should not be displayed
     */
    skippUrlsRequete = [
        'projects?perPage=100'
    ];

    constructor(private loadingScreenService: LoadingScreenService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let displayLoadingScreen = false;
        for (const skippUrl of this.skippUrls) {
            if (new RegExp(skippUrl).test(request.url)) {
                displayLoadingScreen = false;
                break;
            }
        }

        for (const skippItemUrl of this.skippUrlsRequete) {
            if (request.url.indexOf(skippItemUrl) > -1) {
                displayLoadingScreen = false;
                break;
            }
        }

        if (displayLoadingScreen) {
            if (this.activeRequests === 0 && !(request.method === 'POST' && request.url.includes('/message-instants'))) {
                this.loadingScreenService.startLoading();
            }
            this.activeRequests++;

            return next.handle(request).pipe(
                finalize(() => {
                    this.activeRequests--;
                    if (this.activeRequests === 0) {
                        this.loadingScreenService.stopLoading();
                    }
                })
            );
        } else {
            return next.handle(request).pipe(
                catchError((error: HttpErrorResponse) => {
                  if (error.status === 0) {

                    //alert("coupire");
                    // Statut 0 indique généralement une coupure de connexion
                    /*this.loadingScreenService.setConnexionAlert(true);
                    setTimeout(() => {
                      this.loadingScreenService.setConnexionAlert(false);
                    }, 4000);*/
                  }
          
                  return throwError(error);
                }));
        }
        
    }
}

